const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`


const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />

`
const TemplateNotificationBannerStyles = t
export { TemplateNotificationBannerStyles }
